import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  Avatar,
  Button,
  Divider,
  Typography,
  AvatarGroup,
  Checkbox,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Modal,
  styled,
  Box,
  Badge,
  ListItemText,
  ListItemAvatar,
  ListItem,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import NeoinCircleLogo from "../../../../Assets/img/Neoin-circle-logo.png";
import GroupsIcon from "@mui/icons-material/Groups";
import ForumIcon from "@mui/icons-material/Forum";
import { ReactComponent as GiftIcon } from "../../../../Assets/img/icons/Gift-icon.svg";
import { MdOutlinePhoneIphone } from "react-icons/md";
import EmailIcon from "@mui/icons-material/Email";
import useApi from "../../../Utilities/useAPI";
// import frame from "../../../../Assets/img/upload-image.png";
import { Link } from "react-router-dom";
import CryptoJS from "crypto-js";
import { ReactComponent as VerifiedTickN } from "../../../../Assets/img/icons/Verified-icon-new.svg";
import { ReactComponent as NonVerifiedTickNew } from "../../../../Assets/img/icons/Non-verified-icon.svg";
import DefaultProfileBg from "../../../../Assets/img/card/profilebg.png";
import useAvailableHeight from "../../../Custom/UseAvailableHeight";
import { AlertDialog } from "../../MyProfileDetails/ProfessionalProfile";
import { motion } from "framer-motion";
import UserConnectFullViewSkeleton from "../../../LoadingSkeleton/UserConnectFullViewSkeleton";
import { ReactComponent as ConsentIndication } from "../../../../Assets/img/icons/consent_indication.svg";
import { CheckBox } from "@mui/icons-material";
import { useUserDetailContext } from "../../../UserDetailContext";
import { useQuantityContext } from "../../../QuantityContext";
import axios from "axios";
import TextsmsRoundedIcon from "@mui/icons-material/TextsmsRounded";
import SearchIcon from "@mui/icons-material/Search";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import NEOIN_LOGO from "../../../../Assets/img/Neoin-logo.png"
import { useSelector } from "react-redux";
// import { Link } from 'react-router-dom'

const ModalBox = styled(Box)({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "white",
  boxShadow: "0px 12px 24px 0px #919EAB1F, 0px 0px 2px 0px #919EAB33",
  borderRadius: "8px",
  width: "80%",
  maxWidth: "80%",
  maxHeight: "80%",
  overflowY: "auto",
});

const ContactBox = styled(Box)({
  borderBottom: "1px solid #D0D5DD4D",
  padding: "10px 24px",
  fontSize: "14px",
});

const ListBox1 = styled(Box)({
  display: "flex",
  alignItems: "center",
  width: "50%",
  maxWidth: "50%",
});

const ListBox2 = styled(Box)({
  display: "flex",
  alignItems: "center",
  width: "35%",
  maxWidth: "35%",
});

const ListBox3 = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  minWidth: "15%",
  maxWidth: "15%",
  color: "rgb(0, 0, 0, 0.87)",
  fontFamily: "Roboto, sans-serif",
});

const ActiveBadge = styled(Badge)(({ theme, isActive }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: isActive ? "#4CAF50" : "#EB4E3D", // green if active, red if not
    color: isActive ? "#4CAF50" : "#EB4E3D", // match the badge color
    border: "1px solid white",
    right: "30%",
    transform: "scale (1.8) translate (50%, -50%)",
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      content: '""',
      animation: isActive ? "ripple 1.2s infinite ease-in-out" : "",
      border: isActive ? "1px solid currentColor" : "",
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

const UserConnectFullView = () => {
  const { callApiFunction } = useApi();
  const [availableHeight1, Column1Ref] = useAvailableHeight(172);
  const [profileData, setProfileData] = useState(null);
  const [usertoken, setUserToken] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [connectionData, setConnectionData] = useState([]);
  const location = useLocation();
  const objectId = localStorage.getItem("objectId");
  const [selectedCards, setSelectedCards] = useState([]);
  const [contactPersonalData, setContactPersonalData] = useState(null);
  const [contactProfessionalData, setContactProfessionalData] = useState(null);
  const queryParams = new URLSearchParams(location.search);
  const encryptedId = queryParams.get("encryptedId");
  const { userDetails } = useUserDetailContext();
    const ProfessionalData = useSelector(
      (state) => state?.ProfileArray?.professionaProfile
    );

    const Personaldata = useSelector(
      (state) => state?.ProfileArray?.personalProfile?.data
    );

    // console.log("contactPersonalData---", contactPersonalData, contactProfessionalData)

  const apiKey = process.env.REACT_APP_API_KEY;
  const viewerheaders = {
    "x-api-key": apiKey,
    "Content-Type": "application/json",
    Authorization: `Bearer ${usertoken}`,
  };

  // console.log("profileData123", profileData);

  const { handleSuccess, handleFailure, handleInfo } = useQuantityContext();
  const bytes = CryptoJS.AES.decrypt(
    decodeURIComponent(encryptedId),
    "UserDetailsSecretKey"
  );
  const id = bytes.toString(CryptoJS.enc.Utf8);
  const encryptedIdNew = CryptoJS.AES.encrypt(
    id.toString(),
    "UserDetailsSecretKey"
  ).toString();

  const handleSearchClick = () => {
    if (openSearch === true) setOpenSearch(false);
    else setOpenSearch(true);
  };

  const handleInputChange = (event) => {
    setSearchContact(event.target.value);
  };
  const [openSearch, setOpenSearch] = useState(false);
  const [searchContact, setSearchContact] = useState("");
  // const [filteredContacts, setFilteredContacts] = useState(connectionList || []);

  // console.log("log i ",id);
  // Card Access
  const [cardsWithAccess, setCardsWithAccess] = useState([]);
  const navigate = useNavigate();
  const [profileAlert, setProfileAlert] = useState(false);
  const [contactForConsent, setContactForConsent] = useState(null);
  const dialogData = contactForConsent || profileData;

  // console.log("dialogData", dialogData)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await callApiFunction("userDetailedView", {
          referenceId: id,
        });
        // console.log("USERDETAILED VIEW token", response);
        if (response?.status === "SUCCESS") {
          setProfileData(response?.data);
          setUserToken(response?.token);
          // console.log("user token", usertoken);

          const cardNames = response?.data?.card_names?.map(
            (card) => card?.card_name || card?.card_type
          );

          const checkAccessResponse = await callApiFunction(
            "fetchCardAccesssDetails",
            {
              ownerId: id,
              viewerToken: objectId,
              cardNames: cardNames, // Pass card names in array format
            }
          );

          if (checkAccessResponse.statusCode === 200) {
            const accessibleCards = checkAccessResponse.accessResults
              .filter((card) => card.access)
              .map((card) => card.cardName);

            // console.log("accessibleCards:", accessibleCards);

            setCardsWithAccess(accessibleCards);
          }
        }
      } catch (error) {
        console.log("Error:", error);
      }
    };

    fetchData();
  }, []);

  const handleAllConnections = async () => {
    const response = await axios.get(`/usercontact/connections`, {
      headers: viewerheaders,
    });
    const data = response.data;
    // console.log("Data inside the COntact Particular View Page", data);
    if (data.statusCode === 200) {
      setConnectionData(response.data.data);
      setOpenDialog(true);
      // const encryptedContactRefId = CryptoJS.AES.encrypt(member.contact_ref_id.toString(), 'UserDetailsSecretKey').toString();
      // setEncryptedUserRef(encryptedContactRefId);
    }
  };

  const handleCheckboxChange = (cardType) => {
    setSelectedCards((prevSelectedCards) => {
      if (prevSelectedCards.includes(cardType)) {
        // Remove the card if it's already selected
        return prevSelectedCards.filter((card) => card !== cardType);
      } else {
        // Add the card if it's not selected
        return [...prevSelectedCards, cardType];
      }
    });
  };

  const handleSentConsent = async () => {
    // const payload = {
    //   ownerId: id,
    //   cardNames: selectedCards,
    //   viewerToken: objectId,
    // };
   const ownerIdToRequest = contactForConsent
      ? contactForConsent.contact_ref_id
      : id;
    const payload = {
      ownerId: ownerIdToRequest,
      cardNames: selectedCards,
      viewerToken: objectId,
    };
    // console.log("PAYLOADDDD", payload);
    try {
      const response = await callApiFunction("requestCardConsent", payload);
      setSelectedCards([]);
      if (response.requests[0].message === "Access request already exists.") {
        handleInfo("Consent request sent already.");
      } else {
        handleSuccess("consent sent successfully");
      }

      setProfileAlert(false);
      setContactForConsent(null);
    } catch (error) {
      console.log("Error:", error);
      handleFailure("can't able to sent the consent.", error);
    }
  };

  const formatConnectionDate = (dateString) => {
    const dateObj = new Date(dateString);
    const formattedDate = dateObj.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    const formattedTime = dateObj.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return `Connected on: ${formattedDate} at ${formattedTime}`;
  };

  const handleNavigateToProfile = () => {
    // console.log("cardsWithAccess", cardsWithAccess);

    if (
      Array.isArray(cardsWithAccess) &&
      cardsWithAccess.length > 0 &&
      (cardsWithAccess.includes("Personal") ||
        cardsWithAccess.includes("Professional"))
    ) {
      window.open(
        `/profile?encryptedId=${encodeURIComponent(encryptedIdNew)}`,
        "_blank",
        "noopener,noreferrer"
      );
    } else {
      setProfileAlert(true);
    }
  };

  if (!profileData) {
    return <UserConnectFullViewSkeleton />;
  }

  const maskPhone = (phone = "") => {
    if (!phone) return "";
    return phone.replace(/(\d{2})\d+(\d{2})/, "$1******$2");
  };

  const maskEmail = (email = "") => {
    if (!email) return "";
    const [name, domain] = email.split("@");
    if (!name || !domain) return email;
    return name.slice(0, 2) + "******@" + domain;
  };

  const maskDOB = (dob = "") => {
    if (!dob) return "";
    return dob.slice(0, 4) + "-**-**";
  };

  //   const getCardAccess = async () => {
  //   const endpoint = "fetchCardAccesssDetails";
  //   const reqBody = {
  //     ownerId: refId,
  //     viewerToken: objectId,
  //     cardNames: ["Personal", "Professional"],
  //   };
  //   try {
  //     const response = await callApiFunction(endpoint, reqBody);
  //     // console.log("parent token", response?.token);

  //     if (response.statusCode === 200) {
  //       const cardsWithAccess = response.accessResults
  //         .filter((card) => card.access)
  //         .map((card) => card.cardName);

  //       setAccessibleCards(cardsWithAccess);
  //       setLink(response?.token);

  //       // Set initial activeMenu based on access
  //       if (cardsWithAccess.includes("Personal")) {
  //         setActiveMenu("personal_profile");
  //       } else if (cardsWithAccess.includes("Professional")) {
  //         setActiveMenu("professional_profile");
  //       } else {
  //         setProfileAlert(true);
  //       }
  //     }
  //   } catch (error) {
  //     console.log("Error fetching Connection Count data:", error);
  //   }
  // };

  //   const handleContactClick = async (contact) => {
  //   // don't proceed if not verified (as original logic limited link to verified profiles)
  //   if (!contact.is_verified) return;
  //   try {
  //     const reqBody = {
  //       ownerId: contact.contact_ref_id,
  //       viewerToken: objectId,
  //       cardNames: ["Personal", "Professional"],
  //     };
  //     const response = await callApiFunction("fetchCardAccesssDetails", reqBody);
  //     if (response?.statusCode === 200) {
  //       const accessible = response.accessResults
  //         .filter((c) => c.access)
  //         .map((c) => c.cardName);
  //       if (accessible.includes("Personal") || accessible.includes("Professional")) {
  //         // open contact profile
  //         const encryptedContactRefId = CryptoJS.AES.encrypt(
  //           contact.contact_ref_id.toString(),
  //           "UserDetailsSecretKey"
  //         ).toString();
  //         const contactProfileUrl = `/profile?encryptedId=${encodeURIComponent(
  //           encryptedContactRefId
  //         )}`;
  //         window.open(contactProfileUrl, "_blank", "noopener,noreferrer");
  //         return;
  //       }
  //     }
  //     // no access -> show consent dialog for this contact
  //     setContactForConsent(contact);
  //     setProfileAlert(true);
  //   } catch (err) {
  //     console.error("Error checking card access:", err);
  //     setContactForConsent(contact);
  //     setProfileAlert(true);
  //   }
  // };

  const handleContactClick = async (contact) => {
    // console.log("iam contact", contact)
    if (!contact.is_verified) return;
    try {
      const reqBody = {
        ownerId: contact.contact_ref_id,
        viewerToken: objectId,
        cardNames: ["Personal", "Professional"],
      };
      const response = await callApiFunction("fetchCardAccesssDetails", reqBody);
      if (response?.statusCode === 200) {
        const accessible = response.accessResults
          .filter((c) => c.access)
          .map((c) => c.cardName);
        if (accessible.includes("Personal") || accessible.includes("Professional")) {
          // Fetch contact's personal and professional data
          const encryptedContactRefId = CryptoJS.AES.encrypt(
            contact.contact_ref_id.toString(),
            "UserDetailsSecretKey"
          ).toString();
          
          try {
            // Fetch personal profile data
            const personalResponse = await fetch(
              `${process.env.REACT_APP_BACKEND_URL}/userprofile/other/personal_profile`,
              {
                method: "GET",
                headers: viewerheaders
              }
            );
            const personalData = await personalResponse.json();
            setContactPersonalData(personalData?.data);
            // console.log("iam personaldata", personalData )
            // Fetch professional profile data
            const professionalResponse = await fetch(
              `${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/other/professional_profile`,
              {
                method: "GET",
                headers: viewerheaders
              }
            );
            const professionalData = await professionalResponse.json();
            setContactProfessionalData(professionalData?.data);
          } catch (dataError) {
            console.error("Error fetching contact profile data:", dataError);
          }

          // Open contact profile in new tab
          const contactProfileUrl = `/profile?encryptedId=${encodeURIComponent(
            encryptedContactRefId
          )}`;
          window.open(contactProfileUrl, "_blank", "noopener,noreferrer");
          return;
        }
      }
      // no access -> show consent dialog for this contact
      setContactForConsent(contact);
      setProfileAlert(true);
    } catch (err) {
      console.error("Error checking card access:", err);
      setContactForConsent(contact);
      // setProfileAlert(true);
    }
  };

  return (
    <div className="professional-card-view">
      <div
        className="card_consent_page_left d-flex my-3 mx-3 w-100"
        style={{ backgroundColor: "#ffff", overflow: "hidden" }}
      >
        <motion.div
          className="card_consent_page_left my-3 mx-3"
          ref={Column1Ref}
          style={{
            width: "280px",
            minWidth: "280px",
            maxHeight: `${availableHeight1}px`,
            minHeight: `${availableHeight1}px`,
            overflowY: "auto",
            scrollbarWidth: "none",
          }}
          initial={{ x: "-100%" }}
          animate={{ x: 0 }}
          transition={{ type: "tween", duration: 0.5 }}
        >
          <div className="m-3">
            <img src={NeoinCircleLogo} alt="circlelogo" />
            <div className="flex-center mt-5" style={{ position: "relative" }}>
              <Avatar
                src={profileData.user_profile_url}
                alt={`${profileData.first_name} ${profileData.last_name} Avatar`}
                style={{
                  width: "146px",
                  height: "146px",
                  marginBottom: "10px",
                }}
              />
              {profileData.is_verified ? (
                <div className="verifiedcontainer flex-center">
                  <div className="me-3">Verified</div>
                  <div className="icon-verify-symbol flex-center">
                    <VerifiedTickN />
                  </div>
                </div>
              ) : (
                <div
                  className="verifiedcontainer flex-center"
                  style={{ backgroundColor: "#EB4E3D", width: "106px" }}
                >
                  <div className="me-3">Unverified</div>
                  <div className="icon-verify-symbol flex-center">
                    <NonVerifiedTickNew />
                  </div>
                </div>
              )}
            </div>

            <div className="flex-center flex-column mt-3">
              <h5 className="text-center fw-bold mb-2">{`${profileData.first_name} ${profileData.last_name}`}</h5>
              {/* <h5 className='text-center' style={{ fontSize: "18px", color: "#202224", margin: "12px 0px" }}>UID: {profileData.unique_id}</h5> */}
              <h6
                className="text-center mb-2"
                style={{ fontSize: "18px", fontWeight: "400" }}
              >
                {profileData.designation ||
                  profileData.field_of_study ||
                  profileData.title ||
                  "---"}
              </h6>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ fontSize: "16px", textAlign: "center" }}
              >
                {profileData.company ||
                  profileData.institute ||
                  profileData.nickname ||
                  "---"}
              </Typography>

              {/* Connected Profiles */}
              <AvatarGroup className="mt-3 mb-1">
                {profileData?.connected_profiles
                  ?.slice(0, 3)
                  .map((profileUrl, index) => (
                    <Avatar
                      key={index}
                      alt={`Connected Profile ${index + 1}`}
                      src={profileUrl} // Use default avatar if profileUrl is not present
                    />
                  ))}
              </AvatarGroup>

              <div
                className="my-profile-heading-content"
                onClick={handleAllConnections}
              >
                <div className="profile-meta-info mb-2">
                  <GroupsIcon />{" "}
                  <span className="color-blue">
                    {profileData.connection_count}+ Connections
                  </span>
                </div>
              </div>

              {/* <Button className='mt-3' variant='contained' sx={{ backgroundColor: "#0044C6" }} LinkComponent={`/profile/${encryptedId}`} onClick={handleNavigateOtherView}>VIEW PROFILE</Button> */}

              {
                profileData.is_verified === 1 && (
                  // <Link to={`/profile?encryptedId=${encodeURIComponent(encryptedIdNew)}`} target="_blank" rel="noreferrer">
                  <Button
                    className="mt-3"
                    variant="contained"
                    sx={{ backgroundColor: "#0044C6" }}
                    onClick={handleNavigateToProfile}
                  >
                    VIEW PROFILE
                  </Button>
                )
                // </Link>
              }
            </div>
          </div>

          <div className="bottom-full-ContactView my-profile-heading-content justify-content-around">
            <Divider style={{ margin: "10px 0" }} />
            <div className="d-flex align-items-center justify-content-center w-100">
              <div className="profile-meta-info">
                <ForumIcon /> <span> Messages </span>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div
          className="card_consent_page_left d-flex flex-column justify-content-between my-3 me-3"
          style={{
            padding: "20px",
            flexGrow: 1,
            maxHeight: `${availableHeight1}px`,
            minHeight: `${availableHeight1}px`,
            overflowY: "auto",
            scrollbarWidth: "none",
          }}
          initial={{ y: "100%" }}
          animate={{ y: 0 }}
          transition={{ type: "spring", stiffness: 100, damping: 20 }}
        >
          {" "}
          <div>
            <Typography
              variant="h6"
              color="textSecondary"
              style={{ fontSize: "18px" }}
            >
              Other Details
            </Typography>
            <div className="quick-link-containerNew mt-2">
              <div className="full-Screen-View">
                <a
                  className="flex-center flex-column"
                  href={`mailto:${profileData.email}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="outerLayer_icon flex-center">
                    <EmailIcon className="icon-color3" />
                  </div>
                </a>
                <div className="ms-2">{profileData.email}</div>
              </div>

              <div className="d-flex align-items-center mt-3">
                <div className="full-Screen-View">
                  <a
                    className="flex-center flex-column"
                    href={`tel:${profileData.phone_no}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="outerLayer_icon flex-center">
                      <MdOutlinePhoneIphone className="icon-color3" />
                    </div>
                  </a>
                  <div className="ms-2">{profileData.phone_no}</div>
                </div>

                {profileData.dob && (
                  <div className="full-Screen-View ms-3">
                    <div className="outerLayer_icon flex-center">
                      <GiftIcon className="icon-color3" />
                    </div>
                    <div className="ms-2">{profileData.dob || "N/A"}</div>{" "}
                    {/* Handle null DOB */}
                  </div>
                )}
              </div>
            </div>
            <Typography
              variant="h6"
              color="textSecondary"
              className="mt-2"
              style={{ fontSize: "18px" }}
            >
              Cards
            </Typography>
            <div className="others_cards_view d-flex">
              {/* <div className='OtherCardsView'> */}
              <div className="items-container-card">
                {profileData?.card_names?.map((card, index) => {
                  // Skip rendering if card_type is group_family
                  if (card.card_type === "group_family") return null;
                  const isAccessible = cardsWithAccess.includes(card.card_name);
                  return (
                    <div
                      key={index}
                      className={`item-card-display digi-card-new Smaller-screen ms-0 me-3 my-2`}
                    >
                      <a
                        href={`/digital-identity/${card.card_name}/${usertoken}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div
                          className={`digi-card-upper-allcards Smaller-screen`}
                          style={{
                            backgroundImage: `url(${
                              card.profile_pic ||
                              profileData.user_profile_url ||
                              DefaultProfileBg
                            })`,
                          }}
                        >
                          <div
                            className={`digi-card-label-container Smaller-screen`}
                          >
                            <span className="digi-card-label">
                              {card.card_name || card.card_type}
                            </span>
                          </div>
                          <div>
                            <svg
                              className="wave-separator"
                              preserveAspectRatio="xMinYMax meet"
                              viewBox="0 0 366 58"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill="#ffff"
                                d="M0 58V25.4141C14.0576 21.1915 19.0782 18.899 29.6214 16.4243L82.3374 9L131.037 14.4444L180.741 28.303L235.967 44.1414L267.095 48.101L299.226 46.6161L328.346 40.6767L345.918 34.7373L359.975 28.7979L366 25.8282V58H0Z"
                              />
                              <path
                                fill="#0044c6"
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M270.835 37.8259C297.482 38.5583 329.446 33.0627 365.999 15.174L365.999 26.0725C328.089 44.6257 299.049 49.5039 270.55 48.7205C242.18 47.9407 216.909 40.4361 191.422 32.5503C190.216 32.1771 189.008 31.8027 187.799 31.4277C138.042 16.0019 85.2863 -0.353631 0.502197 25.2657C76.7857 -18.7623 140.591 5.40451 190.828 20.9803C192.054 21.3604 193.277 21.7396 194.498 22.1172C220.042 30.0208 244.06 37.0899 270.835 37.8259Z"
                              />
                            </svg>
                            {isAccessible && (
                              <div
                                className={`company-logo-container-cardSection flex-center  Smaller-screen`}
                                style={{ width: "34px", height: "34px" }}
                              >
                                <ConsentIndication />
                              </div>
                            )}
                          </div>
                        </div>

                        <div
                          className={`p-2 digi-card-lower default-card Smaller-screen`}
                        >
                          <h2 className="Name" style={{ fontSize: "18px" }}>
                            {profileData.first_name} {profileData.last_name}
                          </h2>
                          <span className="Profession d-block">----</span>
                        </div>
                      </a>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div>
            {profileData.connection_created_date
              ? formatConnectionDate(profileData.connection_created_date)
              : ""}
          </div>
        </motion.div>
      </div>

      {/* <Dialog
        open={profileAlert}
      // onClose={() => setProfileAlert(false)}
      >
        <DialogTitle>You do not have consent for this action</DialogTitle>
        <hr className='m-0' style={{ border: '1px solid grey' }} />
        <DialogTitle sx={{ fontSize: "12px" }}>Please ask for consent from <strong>{`${profileData.first_name} ${profileData.last_name}`}</strong> to view their Profile.</DialogTitle>
        <DialogContent>
          <div className='profile-consent d-flex flex-column bg-white'
          //  style={{
          //   width: "500px", height: "130px", padding: '16px', alignItems: 'flex-start', gap: '8px'
          // }}
          >
            < div className="d-flex align-item-center" >
              <Checkbox
                checked={selectedCards.includes('Personal')}
                onChange={() => handleCheckboxChange('Personal')}
              />
              <span className='fs-5 pt-1'>Personal</span>
            </div>
            <div className="d-flex align-item-center">
              <Checkbox
                checked={selectedCards.includes('Professional')}
                onChange={() => handleCheckboxChange('Professional')}
              />
              <span className='fs-5 pt-1'>Professional</span>
            </div>
          </div>
        </DialogContent >

        <DialogActions>
          <Button onClick={() => setProfileAlert(false)} variant="outlined">Cancel</Button>
          <Button onClick={handleSentConsent} sx={{ backgroundColor: "#0044c6" }} variant="contained" disabled={selectedCards.length < 1}>
            Ask for Consent
          </Button>
        </DialogActions>
      </Dialog > */}

      <Dialog open={profileAlert} maxWidth="md">
        <DialogTitle>You do not have consent for this action</DialogTitle>
        <hr className="m-0" style={{ border: "1px solid grey" }} />
        <DialogTitle sx={{ fontSize: "12px" }}>
          Please ask for consent from{" "}
          <strong>{`${profileData.first_name} ${profileData.last_name}`}</strong>{" "}
          to view their Profile.
        </DialogTitle>
        <DialogContent>
          <div className="profile-consent bg-white p-4">
            {/* Cards Row */}
            <div className="d-flex justify-content-center gap-5 mb-4">
              {/* Personal Card */}
              <div
                className="official-card position-relative"
                style={{
                  width: "300px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  backgroundColor: "#fff",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  overflow: "hidden",
                }}
              >
                {/* Card Header */}
                <div
                  className="card-header p-3"
                  style={{
                    backgroundColor: "#f8f9fa",
                    borderBottom: "2px solid #0044c6",
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <img src={NEOIN_LOGO} alt='' />
                    <div>
                      <div
                        className="company-name fw-bold"
                        style={{ color: "#333", fontSize: "16px" }}
                      >
                        {profileData.company || "Personal"}
                      </div>
                      <div
                        className="card-type"
                        style={{ color: "#666", fontSize: "12px" }}
                      >
                        Personal Card
                      </div>
                    </div>
                  </div>
                </div>

                {/* Card Body */}
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-4">
                    <img
                      src={
                        profileData.card_names?.find(
                          (card) => card.card_type === "Personal"
                        )?.profile_pic || profileData.user_profile_url
                      }
                      alt="Personal"
                      style={{
                        width: "80px",
                        height: "80px",
                        borderRadius: "8px",
                        objectFit: "cover",
                        border: "2px solid #f0f0f0",
                      }}
                    />
                    <div className="ms-3">
                      <div
                        className="user-name fw-bold fs-5"
                        style={{ color: "#333" }}
                      >
                        {profileData.first_name} {profileData.last_name}
                      </div>
                      <div
                        className="user-title"
                        style={{ color: "#666", fontSize: "14px" }}
                      >
                        Personal card
                      </div>
                    </div>
                  </div>

                  <div className="card-details">
                    <div className="detail-row d-flex mb-2">
                      <div
                        style={{
                          width: "100px",
                          color: "#666",
                          fontSize: "12px",
                        }}
                      >
                        Phone:
                      </div>
                      <div style={{ color: "#333", fontSize: "12px" }}>
                        {maskPhone(profileData.phone_no)}
                      </div>
                    </div>
                    <div className="detail-row d-flex mb-2">
                      <div
                        style={{
                          width: "100px",
                          color: "#666",
                          fontSize: "12px",
                        }}
                      >
                        Email:
                      </div>
                      <div style={{ color: "#333", fontSize: "12px" }}>
                        {maskEmail(profileData.email)}
                      </div>
                    </div>
                    <div className="detail-row d-flex">
                      <div
                        style={{
                          width: "100px",
                          color: "#666",
                          fontSize: "12px",
                        }}
                      >
                        DOB:
                      </div>
                      <div style={{ color: "#333", fontSize: "12px" }}>
                        {maskDOB(profileData.dob)}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Card Footer */}
                <div
                  className="card-footer p-2 text-center"
                  style={{
                    backgroundColor: "#f8f9fa",
                    borderTop: "1px solid #e0e0e0",
                    fontSize: "10px",
                    color: "#666",
                    letterSpacing: "1px",
                  }}
                >
                  PERSONAL CARD
                </div>
              </div>

              {/* Professional Card */}
              <div
                className="official-card position-relative"
                style={{
                  width: "300px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  backgroundColor: "#fff",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  overflow: "hidden",
                }}
              >
                {/* Card Header */}
                <div
                  className="card-header p-3"
                  style={{
                    backgroundColor: "#f8f9fa",
                    borderBottom: "2px solid #28a745",
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                     <img src={NEOIN_LOGO} alt='' />
                    <div>
                      <div
                        className="company-name fw-bold"
                        style={{ color: "#333", fontSize: "16px" }}
                      >
                        {profileData.company || "Professional"}
                      </div>
                      <div
                        className="card-type"
                        style={{ color: "#666", fontSize: "12px" }}
                      >
                        Professional Card
                      </div>
                    </div>
                  </div>
                </div>

                {/* Card Body */}
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-4">
                    <img
                      src={
                        profileData.card_names?.find(
                          (card) => card.card_type === "Professional"
                        )?.profile_pic || profileData.user_profile_url
                      }
                      alt="Professional"
                      style={{
                        width: "80px",
                        height: "80px",
                        borderRadius: "8px",
                        objectFit: "cover",
                        border: "2px solid #f0f0f0",
                      }}
                    />
                    <div className="ms-3">
                      <div
                        className="user-name fw-bold fs-5"
                        style={{ color: "#333" }}
                      >
                        {profileData.first_name} {profileData.last_name}
                      </div>
                     <div
                        className="user-title"
                        style={{ color: "#666", fontSize: "14px" }}
                      >
                        Professional card
                      </div>
                    </div>
                  </div>

                  <div className="card-details">
                    <div className="detail-row d-flex mb-2">
                      <div
                        style={{
                          width: "100px",
                          color: "#666",
                          fontSize: "12px",
                        }}
                      >
                        Department:
                      </div>
                      <div style={{ color: "#333", fontSize: "12px" }}>
                        {profileData.profession_department}
                      </div>
                    </div>
                    <div className="detail-row d-flex mb-2">
                      <div
                        style={{
                          width: "100px",
                          color: "#666",
                          fontSize: "12px",
                        }}
                      >
                        Company:
                      </div>
                      <div style={{ color: "#333", fontSize: "12px" }}>
                        {profileData.company}
                      </div>
                    </div>
                    <div className="detail-row d-flex">
                      <div
                        style={{
                          width: "100px",
                          color: "#666",
                          fontSize: "12px",
                        }}
                      >
                        Role:
                      </div>
                      <div style={{ color: "#333", fontSize: "12px" }}>
                        {profileData.designation}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Card Footer */}
                <div
                  className="card-footer p-2 text-center"
                  style={{
                    backgroundColor: "#f8f9fa",
                    borderTop: "1px solid #e0e0e0",
                    fontSize: "10px",
                    color: "#666",
                    letterSpacing: "1px",
                  }}
                >
                  PROFESSIONAL CARD
                </div>
              </div>
            </div>

            {/* Checkbox Section */}
            <div className="consent-checkboxes d-flex justify-content-center gap-5 mt-4">
              <div
                className="checkbox-item d-flex align-items-center"
                style={{ width: "300px" }}
              >
                <Checkbox
                  checked={selectedCards.includes("Personal")}
                  onChange={() => handleCheckboxChange("Personal")}
                  sx={{
                    "&.Mui-checked": { color: "#0044c6" },
                  }}
                />
                <span className="fs-5 fw-medium">Personal Consent</span>
              </div>

              <div
                className="checkbox-item d-flex align-items-center"
                style={{ width: "300px" }}
              >
                <Checkbox
                  checked={selectedCards.includes("Professional")}
                  onChange={() => handleCheckboxChange("Professional")}
                  sx={{
                    "&.Mui-checked": { color: "#28a745" },
                  }}
                />
                <span className="fs-5 fw-medium">Professional Consent</span>
              </div>
            </div>
          </div>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setProfileAlert(false)} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={handleSentConsent}
            sx={{ backgroundColor: "#0044c6" }}
            variant="contained"
            disabled={selectedCards.length < 1}
          >
            Ask for Consent
          </Button>
        </DialogActions>
      </Dialog>

      {/* <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
      >
        <DialogTitle>You do not have consent for this action</DialogTitle>
        <hr className='m-0' style={{ border: '1px solid grey' }} />

        <DialogContent>

          <div className='profile-consent d-flex flex-column bg-white'>
            <ul>
              {connectionData.map((contact) => (
                <li key={contact.id}>
                  <h2>{contact.first_name} {contact.last_name}</h2>
                  <p>Email: {contact.email}</p>
                  <p>Phone: {contact.phone_no}</p>
                </li>
              ))}
            </ul>
          </div>
        </DialogContent >
      </Dialog > */}

      <Modal open={openDialog} onClose={() => setOpenDialog(false)}>
        <ModalBox>
          <div className="py-4 px-3 d-flex justify-content-between">
            <div className="profile-meta-info d-flex align-items-center ms-4">
              <GroupsIcon />{" "}
              <span className="color-blue">
                {connectionData.length} Connections
              </span>
            </div>
            <div className="d-flex align-items-center">
              <div className={openSearch ? "me-3" : "me-2"}>
                {openSearch === false ? (
                  <IconButton onClick={handleSearchClick}>
                    <SearchIcon className="icon-color" />
                  </IconButton>
                ) : (
                  <TextField
                    placeholder="Search for People"
                    variant="outlined"
                    size="small"
                    value={searchContact}
                    onChange={handleInputChange}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <div className="icon-svg-24 flex-center ml-0">
                            <SearchIcon className="icon-color" />
                          </div>
                        </InputAdornment>
                      ),
                    }}
                    sx={{ width: "320px" }}
                  />
                )}
              </div>
              <IconButton
                onClick={() => {
                  setOpenDialog(false);
                }}
                disableTouchRipple
              >
                <CloseRoundedIcon />
              </IconButton>
            </div>
          </div>
          <Divider
            className="m-2"
            sx={{ backgroundColor: "#DDE0E6", height: "1px", opacity: 1 }}
          />
          <div className="px-3 pb-4">
            {connectionData?.map((contact) => {
              const encryptedContactRefId = CryptoJS.AES.encrypt(
                contact.contact_ref_id.toString(),
                "UserDetailsSecretKey"
              ).toString();
              const contactProfileUrl = `/profile?encryptedId=${encodeURIComponent(
                encryptedContactRefId
              )}`;
              // const contactProfileUrl = contact.profile_url;
              return (
                // Each individual connection goes here
                <ContactBox className="connection-row" key={contact.id}>
                  <ListItem
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "8px",
                      p: 0,
                    }}
                  >
                    <ListBox1
                      component={contact.is_verified ? Link : undefined}
                      to={contactProfileUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                  {/* <ListBox1
                        onClick={() => {
                          if (!contact.is_verified) return;
                          handleContactClick(contact);
                        }}
                        style={{ cursor: contact.is_verified ? "pointer" : "default" }}
                      > */}
                      <ListItemAvatar>
                        <ActiveBadge
                          overlap="circular"
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                          variant="dot"
                          isActive={contact.is_verified} // Pass the isActive prop here
                        >
                          <Avatar
                            src={contact.profile_url}
                            alt={contact.first_name}
                            sx={{
                              height: "50px",
                              width: "50px",
                              marginRight: "12px",
                            }}
                          >
                            {/* {contact.contactName.charAt(0).toUpperCase()} */}
                          </Avatar>
                        </ActiveBadge>
                      </ListItemAvatar>
                      <ListItemText
                        primary={contact.first_name}
                        secondary={
                          <>
                            {contact.designation === "---" ? (
                              // connection.subTitle === '---'
                              <> --- </>
                            ) : (
                              <>
                                <div>{contact.designation}</div>
                                {/* <div>{connection.subTitle}</div> */}
                              </>
                            )}
                          </>
                        }
                        primaryTypographyProps={{ fontWeight: "bold" }}
                        secondaryTypographyProps={{ color: "text.secondary" }}
                      />
                    </ListBox1>

                    <ListBox2>
                      <ListItemText
                        secondary={`Created on ${
                          contact.created_at.split("T")[0]
                        }`}
                      />
                    </ListBox2>
                    <ListBox3>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          mr: 1,
                          borderRadius: "4px",
                          border: "1px solid #0000003B",
                          padding: "6px 12px",
                          cursor: "pointer",
                          display: "none",
                        }}
                      >
                        <TextsmsRoundedIcon
                          sx={{ mr: 1, color: "rgb(0, 0, 0, 0.54)" }}
                        />
                        <span>Message</span>
                      </Box>
                      {/* <IconButton>
                                        <DeleteIcon />
                                    </IconButton> */}
                    </ListBox3>
                  </ListItem>
                </ContactBox>
              );
            })}
          </div>
        </ModalBox>
      </Modal>
    </div>
  );
};

export default UserConnectFullView;
